@if (initialLoading()) {
<div class="flex items-center justify-center py-12">
  <div
    data-testid="carrier-form-wrapper-loading"
    class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
  ></div>
</div>
} @else {
<app-add-form
  #addForm
  data-testid="carrier-form-wrapper-add-form"
  [title]="config.title"
  [formFields]="formFields()"
  [initialData]="formData()"
  (formAction)="onFormAction($event)"
  [headerActions]="config.headerActions"
  [editMode]="editMode"
  [viewMode]="viewMode"
  [loading]="loading()"
  (formValueChanges)="onFormValueChanges($event)"
></app-add-form>
}

<p-toast data-testid="carrier-form-wrapper-toast"></p-toast>
